<template>
  <div class="card-item card-item-accuracy-rating">
    <icon-accuracy class="icon" v-ifield-b-tooltip="iconTooltipText" />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconAccuracy from '@/assets/ifield/ic_positioning-accuracy.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemAccuracy } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemAccuracyRating',
  components: {
    IconAccuracy,
  },
  inheritAttrs: false,
  props: {
    /**
     * 測位精度値
     */
    accuracy: {
      type: Number,
      default: null,
    },
    /**
     * 測位精度評価
     * @values H,M,L,-
     */
    rating: {
      type: String,
      default: null,
    },
    /**
     * 測位状態
     * @values 1,2,3,4,10
     */
    positioningStatus: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { accuracy, rating, positioningStatus } = toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { ratingText } = useUserStatusAdditionalItemAccuracy({
      accuracy,
      rating,
      positioningStatus,
    })
    return { truncTarget, isTruncated, text: ratingText }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {string}
     */
    iconTooltipText: function () {
      return `${this.$t('appCardMemberItemAccuracyRating.accuracyRating')} : ${
        this.text
      }`
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';
</style>
